import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useRecoilValue } from 'recoil';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../hooks/session';
import { schoolListState } from '../../common/atom';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
  TOOLTIP_FONT_SIZE,
} from '../../common/helper';

const DEFAULT_WIDTH = '5rem';
interface Props {
  onChangeTab: (data: number) => void;
  onDownload: () => void;
  showToolTip?: boolean;
}

export const SwRwwTab: React.FC<Props> = ({
  onChangeTab,
  onDownload,
  showToolTip = false,
}) => {
  const navigate = useNavigate();
  const { loginVal } = useSession();
  const schoolList = useRecoilValue(schoolListState);
  const [schools, setSchools] = useState<any[]>([]);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(1);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [tabValue, setTabValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    onChangeTab(newValue);
  };

  return (
    <Box
      className='flex_between'
      sx={{
        backgroundColor: '#fff',
      }}
    >
      <Box
        sx={{
          mb: '2rem',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs value={tabValue} onChange={handleChange}>
          <Tab label='읽기' sx={{ width: DEFAULT_WIDTH }} />
          <Tab
            sx={{ width: DEFAULT_WIDTH }}
            label={
              !showToolTip ? (
                '걷기'
              ) : (
                <Box className='flex_start'>
                  <Typography sx={{ mr: '.2rem' }}>걷기</Typography>
                  <Tooltip
                    title={
                      <Typography fontSize={TOOLTIP_FONT_SIZE}>
                        걸음수가 기록되지 않은 날은 평균 계산에서 제외됩니다.
                      </Typography>
                    }
                    followCursor
                  >
                    <HelpOutlineIcon
                      sx={{ fontSize: '1rem', color: '#999999' }}
                    />
                  </Tooltip>
                </Box>
              )
            }
          />
          <Tab label='쓰기' sx={{ width: DEFAULT_WIDTH }} />
        </Tabs>
      </Box>
      <Button sx={{ ml: '1rem' }} color='info' onClick={onDownload}>
        데이터 다운로드
        <FileDownloadRoundedIcon color='success' />
      </Button>
    </Box>
  );
};
